window.isFrenzyEventApiCall = true;
const frenzy_get_product_json = async function(url, html){

    const response = await fetch(url,{method: "GET"});
    const product = await response.json();
    if(product){
        document.querySelectorAll('.FrenzyProductId_'+product.id).forEach(function(this_section){
          let getVariantID = '';
          if(this_section){
            getVariantID = this_section.getAttribute("data-variantid"); 
             let getCurrentVariant = '';
             let newPrice = '';
             let newComparePrice = '';
             let price = '';
             let compare_price = '';
            if(getVariantID.length < 14){
                getCurrentVariant = product.variants[0];
                newPrice = Math.round(getCurrentVariant.price / 100);
                newComparePrice = Math.round(getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price / 100 : 0);
                price =  money_format_Frenzy(getCurrentVariant.price / 100 * 100, frenzy_shop_currency);
                compare_price = money_format_Frenzy(newComparePrice * 100, frenzy_shop_currency);  
            }else{
              getCurrentVariant = (product.variants || []).find((y) => (y.id == getVariantID));
              newPrice = Math.round(getCurrentVariant.price / 100);
              newComparePrice = Math.round(getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price / 100 : 0);
              price =  money_format_Frenzy(getCurrentVariant.price / 100 * 100, frenzy_shop_currency);
              compare_price = money_format_Frenzy(newComparePrice * 100, frenzy_shop_currency);  
            }
            this_section.querySelector('.frenzy_product_price_sale').innerHTML = '<span class="money">'+price+'</span>';
            if(getCurrentVariant.compare_at_price > getCurrentVariant.price && getCurrentVariant.compare_at_price != 0  && getCurrentVariant.compare_at_price != null){
              this_section.querySelector('.frenzy_product_price_compare').innerHTML = '<span class="money">'+compare_price+'</span>';  
              // this_section.querySelector('.frenzy_product_price_compare').innerHTML = '';  
            }
            
 //           console.log("I'd like to look up the sibling text for " + product.handle + " please");
            // if(document.querySelector("[data-handle='" + product.handle + "']")){
            //   this_section.querySelector('.sibling-products').innerHTML = "Available in " + document.querySelector("[data-handle='" + product.handle + "']")?.getAttribute("data-siblingtext");
            // }
          }
        });
    }
}

const get_product_metafields_json = async function(url, html){
    const response = await fetch(url,{method: "GET"});
    const product = await response.json();

	 console.log("get_product_metafields_json:::");
	 console.log(product);
/*
    if(product){
        document.querySelectorAll('.FrenzyProductId_'+product.id).forEach(function(this_section){
          let getVariantID = '';
          if(this_section){
            getVariantID = this_section.getAttribute("data-variantid"); 
             let getCurrentVariant = '';
             let newPrice = '';
             let newComparePrice = '';
             let price = '';
             let compare_price = '';
            if(getVariantID.length < 14){
                getCurrentVariant = product.variants[0];
                newPrice = Math.round(getCurrentVariant.price / 100);
                newComparePrice = Math.round(getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price / 100 : 0);
                price =  money_format_Frenzy(getCurrentVariant.price / 100 * 100, frenzy_shop_currency);
                compare_price = money_format_Frenzy(newComparePrice * 100, frenzy_shop_currency);  
            }else{
              getCurrentVariant = (product.variants || []).find((y) => (y.id == getVariantID));
              newPrice = Math.round(getCurrentVariant.price / 100);
              newComparePrice = Math.round(getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price / 100 : 0);
              price =  money_format_Frenzy(getCurrentVariant.price / 100 * 100, frenzy_shop_currency);
              compare_price = money_format_Frenzy(newComparePrice * 100, frenzy_shop_currency);  
            }
            this_section.querySelector('.frenzy_product_price_sale').innerHTML = '<span class="money">'+price+'</span>';
            if(getCurrentVariant.compare_at_price > getCurrentVariant.price && getCurrentVariant.compare_at_price != 0  && getCurrentVariant.compare_at_price != null){
              this_section.querySelector('.frenzy_product_price_compare').innerHTML = '<span class="money">'+compare_price+'</span>';  
              // this_section.querySelector('.frenzy_product_price_compare').innerHTML = '';  
            }
            
			 console.log("get_product_metafields_json:::");
			 console.log(product);
			 
          }
        });
    }
  */
}

window.FrenzyProductGridChangeCallBack = function(html,data){
  var product_id = data?.product_id;
  const varint_id = data.product_id_variant.split("_");
  html.querySelector('.frenzy_product_price_meta').setAttribute("data-variantid",varint_id[1]);
  html.querySelector('.frenzy_product_price_meta').classList.add("FrenzyProductId_"+product_id);
  var product_handle = data?.org_prod_url.split('?') ;
  frenzy_get_product_json(window.Shopify.routes.root + 'products/'+product_handle[0]+'.js', html).then(frenzy_product_response => {return frenzy_product_response});
/*
	console.log("***** " + window.Shopify.routes.root + 'products/'+product_id+'/metafields.js');

  get_product_metafields_json(window.Shopify.routes.root + 'products/'+product_id+'/metafields.json', html).then(product_response => {return product_response});
*/

  let colorCountHtml = '';
  (collection_obj || []).find((x) => {
    if (x.id === data?.smf_swatch_collection && x.count > 0) {
      colorCountHtml += '<span data-handle="'+product_handle[0]+'" data-siblingtext="'+x.count+' colors"></span>';
    }
  });
  document.querySelector('body').insertAdjacentHTML('beforeend',colorCountHtml);
  if(document.querySelector("[data-handle='" + product_handle[0] + "']")){
    html.querySelector('.frenzy_product_item[data-pro_id="'+data?.product_id+'"] .sibling-products').innerHTML = "Available in " + document.querySelector("[data-handle='" + product_handle[0] + "']")?.getAttribute("data-siblingtext");
  }
}

const bundle_frenzy_get_product_json = async function(url, html,settingData){
  jQuery.getJSON(url, function(product) {
          var getVariantID = html.getAttribute('value');
          const $frenzy_bundle_parent = html.closest(
                    ".frenzy_bundle_innercode"
                  );
          // const getVariantID = this_section.getAttribute("data-variantid");
          const getCurrentVariant = (product.variants || []).find((y) => (y.id == getVariantID));
          const newPrice = getCurrentVariant.price / 100;
          const newComparePrice = getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price : 0 / 100;
          const max_price = product.price_max;
          const min_price = product.price_min;
          var compare_price = getCurrentVariant.compare_at_price? getCurrentVariant.compare_at_price : 0 / 100;
          var price = '';

         console.log("bundle_frenzy_get_product_json:::");
         console.log(product);
         
         
          if(min_price != max_price){
              // price = money_format_Frenzy(newPrice * 100, frenzy_shop_currency);
            price = newPrice * 100;
          }else{
            // price =  money_format_Frenzy(newPrice * 100, frenzy_shop_currency);
            price =  newPrice * 100;
            if(min_price == max_price && newPrice != null && newComparePrice != '' && newPrice < newComparePrice){
               // compare_price = money_format_Frenzy(newComparePrice * 100, frenzy_shop_currency); 
               compare_price = newComparePrice * 100;
            }
          }
      var frenzy_bundle_sale_price =price;
     if(settingData?.discount_amount > 0){
                    is_discount = true;
                frenzy_bundle_sale_price =
                  settingData?.discount_type == "percentage" ? (price  * (100 - settingData?.discount_amount)) / 100 :price  - settingData?.discount_amount * 100;
            }
          // html.querySelector('.frenzy_bundle_product_main_price').innerHTML = '<span class="money">'+price+'</span>';
        
           html.setAttribute('data-price',frenzy_bundle_sale_price);
           html.setAttribute('data-orgprice',price);
          if(compare_price != ''){
            html.setAttribute('data-org_msrp_price',compare_price);
          }else{
            // html.setAttribute('data-org_msrp_price',price);
          }
          $frenzy_bundle_final_total(
                    $frenzy_bundle_parent,
                    settingData
                  );
  })
}
const FrenzyAfterBundlePriceChangeCallBack = async function(data,settingData){
  const variant_option_type = settingData?.select_option == "all_options" ? "all_options" : "size";
  // console.log("///data///", data);
  document.querySelectorAll('.frenzy_pb_details .frenzy_bundle_product_grid').forEach(function(this_click){
    var product_handle = this_click.querySelector('.frenzy_bundle_product_details_inner .frenzy_bundle_product_checkbox_val').getAttribute('data-handle');
     var html =  this_click.querySelector('.frenzy_bundle_product_details_inner .frenzy_bundle_product_checkbox_val');

    bundle_frenzy_get_product_json(window.Shopify.routes.root + 'products/'+product_handle+'.js', html,settingData).then(frenzy_product_response => {return frenzy_product_response});
  });
}
// window.FrenzyBundleAfterDetailsCallBack = function(data, html){
//   (data || []).map(
//      ($bundle_product, $bundle_idx) => {
//        let $frenzy_bundle_sale_price = $bundle_product.org_price * 100,
//        $frenzy_bundle_compare_price = $bundle_product.org_price * 100;

//        var t = '';
//        t = document.querySelector('.frenzy_pb_details .frenzy_bundle_product_grid[data-index="'+$bundle_idx+'"]');

//       const product_handle = $bundle_product.org_prod_url.split("?");
//        bundle_frenzy_get_product_json(window.Shopify.routes.root + 'products/'+product_handle[0]+'.js', t).then(frenzy_product_response => {return frenzy_product_response});
       
//      });
// }

window.frenzyCartCallBack = async (res) => {
  const sectionId = 'cart-drawer';
  if (!window.customElements.get("cart-drawer")) {
    window.customElements.define("cart-drawer", class extends HTMLElement {
      connectedCallback() {
        if (!this.shadowRoot) this.attachShadow({ mode: "open" });
      }
    });
  }
  const html = await fetch(`${Shopify.routes.root}?section_id=${sectionId}`).then(res => res.text());
  const dom = new DOMParser().parseFromString(html, "text/html");
  const section = dom.getElementById(`shopify-section-${sectionId}`);
  const cartDrawerHTML = section?.querySelector("cart-drawer")?.innerHTML;
  if (!cartDrawerHTML) {
    console.error("Cart drawer HTML not found in section");
    return;
  }
  const newContent = document.createRange().createContextualFragment(cartDrawerHTML);
  let cartDrawerElement = document.querySelector("cart-drawer");
  if (!cartDrawerElement) {
    cartDrawerElement = document.createElement("cart-drawer");
    document.body.appendChild(cartDrawerElement);
  }
  cartDrawerElement.replaceChildren(...newContent.children);
  const cart = await fetch("/cart.js").then(res => res.json());
  const itemCount = cart.item_count;
  cartDrawerElement.classList.toggle("drawer--center-body", itemCount === 0);
  cartDrawerElement.dispatchEvent(new CustomEvent("cart-drawer:refreshed", { bubbles: true }));
  openCartDrawer(cartDrawerElement);
};
function openCartDrawer(cartDrawerElement) {
  if (cartDrawerElement.show) {
    cartDrawerElement.show();
  } else {
    cartDrawerElement.classList.add("open");
  }
}





function frenzyQuickAddClick(this_click){
  if(this_click.closest(".frenzy_product_item").querySelector('figure').querySelector('.frenzy_options.is-open')){
    this_click.closest(".frenzy_product_item").querySelector('figure').querySelector('.frenzy_options')?.classList.remove('is-open');
  }else{
    document.querySelector('.frenzy_options.is-open')?.classList.remove('is-open')
    this_click.closest(".frenzy_product_item").querySelector('figure').querySelector('.frenzy_options')?.classList.add('is-open');
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  const viewportWidth = document.documentElement.clientWidth;
  if(viewportWidth < 768){
    setTimeout(() => {
    const closeButton = document.querySelector('.frenzy_mobile_search_box_close_button');
    if(closeButton){
      closeButton.addEventListener('click',function(e){
        document.querySelector('#shopify-section-header').style.zIndex = '5';
        document.querySelector('#shopify-section-header').querySelector('#Search').setAttribute('aria-hidden','true');
        document.querySelector('.PageOverlay').classList.remove('is-visible');
        document.documentElement.classList.remove('no-scroll');
      });
    }
    },1000)
  }
});


window.frenzyAnimationCallBack = () => {
    let frenzyUpdatePlaceholder = '';
    const gridLength = 28;
    frenzyUpdatePlaceholder += '<div class="frenzy_collection_page_loader_content">';
    frenzyUpdatePlaceholder += '<div class="frenzy_container">';
    frenzyUpdatePlaceholder += '<div class="frenzy_topbar_loader_content">';
    frenzyUpdatePlaceholder += '<div class="frenzy_filter_loader_content "></div>';
    frenzyUpdatePlaceholder += '<div class="frenzy_sorting_loader_content"></div>';
    frenzyUpdatePlaceholder += '<div class="frenzy_empty_loader_content"></div>';
    frenzyUpdatePlaceholder += '<div class="frenzy_orientation_loader_content">';
    frenzyUpdatePlaceholder += '<span></span>';
    frenzyUpdatePlaceholder += '</div>';
    frenzyUpdatePlaceholder += '</div>';
    frenzyUpdatePlaceholder += '<div class="frenzy_content_loader_row">';
    frenzyUpdatePlaceholder += '<div class="frenzy_loader_row loader_grid_2">';
    for(var i = 0; i <= gridLength; i++ ){
      frenzyUpdatePlaceholder += '<div class="frenzy_loader_grid">';
      frenzyUpdatePlaceholder += '<figure>';
      frenzyUpdatePlaceholder += '<img src="https://cdn.frenzyai.click/plugin/placeholder.png" />';
      frenzyUpdatePlaceholder += '</figure>';
      frenzyUpdatePlaceholder += '<p></p>';
      frenzyUpdatePlaceholder += '</div>';
    }
    frenzyUpdatePlaceholder += '</div>';
    frenzyUpdatePlaceholder += '</div>';
   frenzyUpdatePlaceholder += '</div>';
   frenzyUpdatePlaceholder += '</div>';
    return frenzyUpdatePlaceholder;
}

